import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="/images/favicon.webp" 
              alt="Brit Wager Logo" 
              className="w-10 h-10 object-contain"
            />
            <span className="text-white text-2xl font-bold">Brit Wager</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-white/90 hover:text-white transition-colors">
              Home
            </Link>
            <Link to="/guides" className="text-white/90 hover:text-white transition-colors">
              Guides
            </Link>
            <Link to="/news" className="text-white/90 hover:text-white transition-colors">
              News
            </Link>
            <Link to="/reviews" className="text-white/90 hover:text-white transition-colors">
              Reviews
            </Link>
          </nav>

         

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 space-y-4">
            <Link to="/" className="block text-white/90 hover:text-white transition-colors py-2">
              Home
            </Link>
            <Link to="/guides" className="block text-white/90 hover:text-white transition-colors py-2">
              Guides
            </Link>
            <Link to="/news" className="block text-white/90 hover:text-white transition-colors py-2">
              News
            </Link>
            <Link to="/reviews" className="block text-white/90 hover:text-white transition-colors py-2">
              Reviews
            </Link>
           
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;

